import { useTranslation } from "react-i18next"
import DocumentoSettingsArchivosAdjuntos from "./DocumentoSettingsArchivosAdjuntos"
import DocumentoSettingsColorPrincipal from "./DocumentoSettingsColorPrincipal"
import DocumentoSettingsCuentaContable from "./DocumentoSettingsCuentaContable"
import DocumentoSettingsDivisa from "./DocumentoSettingsDivisa"
import DocumentoSettingsNuevosCampos from "./DocumentoSettingsNuevosCampos"

const DocumentoSettings = ({
  titleDocumento,
  sinValorar,
  setSinValorar,
  observacionCesion,
  facturaRecurrente,
  isEditViewFacturaRecurrente,
  typeDocumento,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  return (
    <div className='container settings-container'>
      <h5 className='p-0 m-0 text-left f-21 font-weight-500 text-gedesco'>
        {t("crear.facturaRec.customDocument")}
        {titleDocumento.toLowerCase()}
      </h5>
      <DocumentoSettingsCuentaContable
        cuentaContableRecurrentes={facturaRecurrente?.cuentaContableCategoriaId}
      />

      {/* @ts-expect-error TS(2322): Type '{ divisaRecurrentes: $TSFixMe; }' is not assignab... */}
      <DocumentoSettingsDivisa divisaRecurrentes={facturaRecurrente?.divisa} />

      <DocumentoSettingsColorPrincipal />

      <DocumentoSettingsNuevosCampos
        titleDocumento={titleDocumento}
        sinValorar={sinValorar}
        setSinValorar={setSinValorar}
        observacionCesion={observacionCesion}
        facturaRecurrente={facturaRecurrente}
        typeDocumento={typeDocumento}
      />
      {!isEditViewFacturaRecurrente ? (
        <DocumentoSettingsArchivosAdjuntos />
      ) : null}
    </div>
  )
}

export default DocumentoSettings
